import { Injectable } from "@angular/core";
import { ReplaySubject } from "rxjs";
import { Store } from "@ngxs/store";
import { SetFilter } from "../state/apai.actions";
import { EnabledCompaniesStoreService } from "./enabled-companies-store.service";
import { CompaniesEnabled } from "./enabled-companies.types";

@Injectable({
  providedIn: "root",
})
export class ApaiEnabledService {
  enabledCompaniesSubject = new ReplaySubject<CompaniesEnabled>();
  enabledCompanies$ = this.enabledCompaniesSubject.asObservable();
  enabledCompanies: CompaniesEnabled;

  constructor(
    private ngxsStore: Store,
    private enabledCompaniesStore: EnabledCompaniesStoreService,
  ) {}

  fetchConfig() {
    const cachedEntry = this.enabledCompaniesStore.getStoredCompaniesEnabled(
      "apai",
    );
    if (cachedEntry) {
      this.enabledCompanies = cachedEntry;
      this.enabledCompaniesSubject.next(cachedEntry);
    }

    const sub = this.enabledCompaniesStore.fetchCompaniesEnabled("apai");
    if (!sub) {
      console.warn("No way2vat data found in local storage");
      return;
    }

    sub.subscribe({
      next: (enabledCompaniesData) => {
        this.enabledCompanies = enabledCompaniesData;
        this.enabledCompaniesSubject.next(enabledCompaniesData);

        const firstEnabledCompany = enabledCompaniesData.companies.find(
          (company) => company.enabled,
        );
        if (firstEnabledCompany) {
          this.ngxsStore.dispatch(
            new SetFilter({
              companyId: firstEnabledCompany.id,
              page: 1,
            }),
          );
        }
      },
      error: (error) => {
        console.error("Error fetching company enabled products:", error);
      },
    });
    return sub;
  }
}
